import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { Porder } from '../entities/porder';


export class PorderRequest extends BaseRequest {
  porder : Porder;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.porder = new Porder();
  }
}